import { defineMachine, runMachine } from './buildMachine';
import { Ctx, makeCtx, makeSnap, Snap } from './core';
import { consent } from './consent';
import { eligibility } from './eligibility';
import { events } from './events';
import { idConnect } from './idConnect';
import { init } from './init';
import { tail } from './tail';
import { consoleLogger } from '@shared/logging/consoleLogger';

export function makeMachine() {
  const [ctx, blocks, halt] = defineMachine<Ctx, Snap>(
    'Utiq',
    makeCtx,
  )(({ makeEffect, makeEffectGroup }) => [
    // makeEffect(
    //   'startEval',
    //   (_, { log, skip, snap }) => {
    //     log('now', snap.now);
    //     log('cookies', snap.cookies);
    //     log('didomi', snap.didomi);
    //     log('localStorage', snap.localStorage);
    //     log('queryString', snap.queryString);
    //     log('sessionStorage', snap.sessionStorage);
    //     return skip();
    //   },
    //   () => {},
    // ),

    makeEffect(
      'utiqPassEverPopulated',
      (_, { pass, skip, ctx, snap }) => {
        if (!ctx.times.utiqPassEverPopulated && !!snap.localStorage.utiqPass) {
          return pass(null);
        }

        return skip();
      },
      (_, { ctx, snap }) => {
        ctx.times.utiqPassEverPopulated = snap.now;
      },
    ),

    makeEffectGroup('init', (_, { pass }) => pass(null), init),
    makeEffectGroup('events', (_, { pass }) => pass(null), events),

    makeEffectGroup(
      'eligibility',
      (_, { cond, ctx }) => cond(!ctx.isIdConnect, '!ctx.isIdConnect'),
      eligibility,
    ),

    makeEffectGroup(
      'consent',
      (_, { cond, ctx }) => cond(!ctx.isIdConnect, '!ctx.isIdConnect'),
      consent,
    ),

    makeEffectGroup('idConnect', (_, { pass }) => pass(null), idConnect),
    makeEffectGroup('tail', (_, { pass }) => pass(null), tail),
  ]);

  function run() {
    return runMachine(
      [ctx, blocks, halt],
      makeSnap,
    )(
      // 2 /*
      (
        {
          silent: 0,
          error: 0,
          warn: 0,
          info: 1,
          verbose: 2,
        } as const
      )[consoleLogger.logLevel],
      // */,
    );
  }

  return { ctx, run, makeSnap: makeSnap.bind(null, ctx) };
}

export const utiqMachine = ((
  window as typeof window & { utiqMachine?: ReturnType<typeof makeMachine> }
).utiqMachine ||= makeMachine());
